import { render, staticRenderFns } from "./MajorBodyPartsForm.vue?vue&type=template&id=2657628d"
import script from "./MajorBodyPartsForm.vue?vue&type=script&lang=js"
export * from "./MajorBodyPartsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports